
import React, { useState } from 'react';
import { Volume2, VolumeX, Play } from 'lucide-react';

const VideoSection: React.FC = () => {
  const [isMuted, setIsMuted] = useState(true);

  return (
    <section className="py-24 bg-zinc-950 border-t border-zinc-900 relative overflow-hidden">
      {/* Abstract Background */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute right-0 top-0 w-1/2 h-full bg-gradient-to-l from-[#c17c0c]/20 to-transparent"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Text Content */}
          <div className="order-2 lg:order-1">
             <div className="inline-flex items-center space-x-2 text-[#c17c0c] mb-6">
                <div className="w-8 h-px bg-[#c17c0c]"></div>
                <span className="text-xs font-mono uppercase tracking-[0.2em] font-bold">Demonstração Tática</span>
             </div>
             
             <h2 className="text-4xl md:text-5xl font-black mb-8 uppercase italic tracking-tighter text-white">
               Sua Vantagem <br/>
               <span className="text-[#c17c0c]">Competitiva</span>
             </h2>
             
             <div className="prose prose-invert">
               <p className="text-xl text-zinc-300 font-light leading-relaxed mb-8 border-l-4 border-[#c17c0c] pl-6">
                 "Não jogue para competir, jogue para vencer. Assista à demonstração e entenda como substituir o 'achismo' por matemática eleitoral de alta precisão."
               </p>
               <p className="text-zinc-500 text-sm leading-relaxed font-mono uppercase tracking-wide">
                 Identifique oportunidades, costure alianças e blinde sua campanha com a tecnologia mais avançada do mercado.
               </p>
             </div>
          </div>

          {/* Video Box */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[320px] aspect-[9/16] bg-black rounded-[2.5rem] border-4 border-zinc-900 shadow-2xl overflow-hidden group">
               
               {/* Video */}
               <video 
                  src="https://legislativo.pro/img/guruvoto.mp4" 
                  className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
                  autoPlay 
                  loop 
                  muted={isMuted}
                  playsInline
               />
               
               {/* Controls & Overlays */}
               <div className="absolute inset-0 pointer-events-none">
                  {/* Scanline */}
                  <div className="scanline z-10"></div>
                  
                  {/* Glass Reflection */}
                  <div className="absolute inset-0 bg-gradient-to-tr from-white/5 to-transparent opacity-20 z-20 rounded-[2.2rem]"></div>
                  
                  {/* Live Indicator */}
                  <div className="absolute top-6 right-6 flex items-center space-x-2 bg-black/60 backdrop-blur-md px-3 py-1.5 rounded-full border border-zinc-800 z-30">
                      <div className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"></div>
                      <span className="text-[8px] font-mono text-white uppercase tracking-widest">REC</span>
                  </div>
               </div>

               {/* Mute Button (Interactive) */}
               <button 
                 onClick={() => setIsMuted(!isMuted)}
                 className="absolute bottom-8 right-8 z-40 w-12 h-12 rounded-full bg-[#c17c0c] text-black flex items-center justify-center hover:bg-white transition-colors shadow-lg hover:scale-110 active:scale-95 duration-200"
               >
                 {isMuted ? <VolumeX size={20} /> : <Volume2 size={20} />}
               </button>

               {/* Play Icon Overlay (Decorative/Status) */}
               <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full border border-white/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-30">
                  <Play size={24} className="text-white fill-white ml-1" />
               </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default VideoSection;
